"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { setCoreSnowplowUserContext } from "./utils";
import { PageTracker } from "../PageTracker.component";
/**
 * Tracks snowplow activity within a core page.
 */
export var CorePageTracker = function (props) {
    var isEnabledEnv = props.isEnabledEnv, title = props.title;
    var isEnabled = isEnabledEnv === "true";
    return (_jsx(PageTracker, { isEnabled: isEnabled, setUserContext: setCoreSnowplowUserContext, title: title }));
};
